module.exports = __webpack_public_path__ + "static/premium-ae5110c7f035c7503c850ca9a6eab3f5.pdf";